import _styled from '@emotion/styled/base';
import 'react';
import { BsViewList } from '@react-icons/all-files/bs/BsViewList';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { Carousel as Carousel$1 } from './Carousel.js';
import { CarouselInspector } from './Carousel.Inspector.js';
import { jsx } from '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Carousel = decorateComponent(Carousel$1, 'block', {
  id: 'carousel',
  label: '캐로셀',
  defaultProps: {
    autoPlay: false,
    hasArrow: true,
    align: 'center',
    hasPagination: true,
    childWidthPercentage: 100
  },
  disallowedAncestors: ['a', 'coupon', 'carousel', 'tabButton'],
  renderIcon: function renderIcon() {
    return jsx(Icon, null);
  },
  renderInspector: CarouselInspector
});
var Icon = /*#__PURE__*/_styled(BsViewList, process.env.NODE_ENV === "production" ? {
  target: "elwaith0"
} : {
  target: "elwaith0",
  label: "Icon"
})(process.env.NODE_ENV === "production" ? {
  name: "jbgpyq",
  styles: "transform:rotate(90deg)"
} : {
  name: "jbgpyq",
  styles: "transform:rotate(90deg)",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QitCIiwiZmlsZSI6ImluZGV4LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBCc1ZpZXdMaXN0IH0gZnJvbSAnQHJlYWN0LWljb25zL2FsbC1maWxlcy9icy9Cc1ZpZXdMaXN0JztcblxuaW1wb3J0IHsgZGVjb3JhdGVDb21wb25lbnQgfSBmcm9tICcuLi8uLi9kb2N1bWVudENvbXBvbmVudHMnO1xuaW1wb3J0IHsgQ2Fyb3VzZWwgfSBmcm9tICcuL0Nhcm91c2VsJztcbmltcG9ydCB7IENhcm91c2VsSW5zcGVjdG9yIH0gZnJvbSAnLi9DYXJvdXNlbC5JbnNwZWN0b3InO1xuXG5leHBvcnQgZGVmYXVsdCBkZWNvcmF0ZUNvbXBvbmVudChDYXJvdXNlbCwgJ2Jsb2NrJywge1xuICBpZDogJ2Nhcm91c2VsJyxcbiAgbGFiZWw6ICfsupDroZzshYAnLFxuICBkZWZhdWx0UHJvcHM6IHtcbiAgICBhdXRvUGxheTogZmFsc2UsXG4gICAgaGFzQXJyb3c6IHRydWUsXG4gICAgYWxpZ246ICdjZW50ZXInLFxuICAgIGhhc1BhZ2luYXRpb246IHRydWUsXG4gICAgY2hpbGRXaWR0aFBlcmNlbnRhZ2U6IDEwMCxcbiAgfSxcbiAgZGlzYWxsb3dlZEFuY2VzdG9yczogW1xuICAgICdhJyxcbiAgICAnY291cG9uJyxcbiAgICAnY2Fyb3VzZWwnLFxuICAgICd0YWJCdXR0b24nLFxuICBdLFxuICByZW5kZXJJY29uOiAoKSA9PiA8SWNvbiAvPixcbiAgcmVuZGVySW5zcGVjdG9yOiBDYXJvdXNlbEluc3BlY3Rvcixcbn0pO1xuXG5jb25zdCBJY29uID0gc3R5bGVkKEJzVmlld0xpc3QpYFxuICB0cmFuc2Zvcm06IHJvdGF0ZSg5MGRlZyk7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { Carousel as default };
//# sourceMappingURL=index.js.map
